import React from "react";
import "../../pages/PlanningMap/index.css";
import { FormGroup, CustomInput, Col, Button } from "reactstrap";
import Constant from "constants/index";
import DataWidget from "../DataWidget";
import SelectedPolygon from "./SelectedPolygon";

type RightCornerProps = {
  state: any;
  nearbyLocationTypeSelection: (item: any) => void;
  showNearbyLocationFirst: boolean;
  setMapSettings: (att: string, checked: boolean) => void;
  setShowTrafficCounting: (checked: boolean) => void;
  getExternalRetailDataDetail: () => void;
  getExternalFoodAndBeveragePoints: () => void;
  getExternalFoodAndBeverageDeliveryPoints: () => void;
  getStaticDemandPoints: () => void;
  embedMode?: boolean;
  toggleShowPlanningPolygons: () => void;
  toggleSitePlanningCommentUI: (polygon: any) => void;
  editPlanningPolygon: (polygon: any) => void;
};

const RightCorner = ({
  state,
  nearbyLocationTypeSelection,
  setMapSettings,
  setShowTrafficCounting,
  showNearbyLocationFirst,
  getExternalFoodAndBeverageDeliveryPoints,
  getExternalFoodAndBeveragePoints,
  getExternalRetailDataDetail,
  getStaticDemandPoints,
  embedMode,
  toggleShowPlanningPolygons,
  editPlanningPolygon,
  toggleSitePlanningCommentUI,
}: RightCornerProps) => {
  const {
    summaryData,
    foodAndBeverageCategoryDemand,
    foodAndBeverageDemand,
    foodAndBeverageDeliveryDemand,
    externalRetailDemand,
    staticDemand,
    nearbyLocationTypeSummary,
    isGetExternalFoodAndBeverageData,
    isGetStaticDemandData,
    isGetWardsDemographics,
    isGetExternalFoodAndBeverageDeliveryData,
    isGetNearbyLocationSummary,
    mapSettings,
    isGetExternalRetailData,
    isShowTrafficCounting,
    isGetTrafficCountingData,
    mapBoundary,
    showPlanningPolygon,
    planningPolygons,
    selectedFeatureIndexes,
  } = state;
  const summaryDataLayout: Array<any> = [
    {
      dataObject: summaryData,
      attributeName: "total_population",
      type: "single_number",
      unit: "người",
      title: "Dân số phường",
      isLoading: isGetWardsDemographics,
      customFooterComponent: (
        <div>
          <FormGroup>
            <CustomInput
              className="site-planning__map-toolbar_section-switch"
              id="showWardBoundaryCustomInput"
              type="switch"
              label="Hiện ranh giới phường"
              onChange={(e) =>
                setMapSettings("showWardBoundary", e.target.checked)
              }
              checked={mapSettings.showWardBoundary}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              className="site-planning__map-toolbar_section-switch"
              id="showWardDensityCustomInput"
              type="switch"
              label="Hiện mật độ dân số phường"
              onChange={(e) => {
                setMapSettings("showWardBoundary", e.target.checked);
                setMapSettings("showWardDensity", e.target.checked);
              }}
              checked={mapSettings.showWardDensity}
            />
          </FormGroup>
        </div>
      ),
    },
    {
      dataObject: summaryData,
      type: "bar_chart",
      title: "Độ tuổi",
      attributeName: "age_range_population",
      subAttributeLabelName: "age_range",
      subAttributeValueName: "total_population",
      isLoading: isGetWardsDemographics,
    },
    // {
    //   type: "other",
    //   unit: "người",
    //   title: "Đếm traffic",
    //   isLoading: isGetTrafficCountingData,
    //   customFooterComponent: (
    //     <div>
    //       <FormGroup>
    //         <CustomInput
    //           className="site-planning__map-toolbar_section-switch"
    //           id="toggleIsShowTrafficCounting"
    //           type="switch"
    //           label="Hiện lượt đo traffic"
    //           onChange={(e) => setShowTrafficCounting(e.target.checked)}
    //           checked={isShowTrafficCounting}
    //         />
    //       </FormGroup>
    //     </div>
    //   ),
    // },
    {
      dataObject: externalRetailDemand,
      attributeName: "total_revenue_last_3_month",
      type: "single_number",
      unit: "VND (tỉ lệ)",
      title: "Nhu cầu bán lẻ (ước tính doanh thu 3 tháng)",
      isLoading: isGetExternalRetailData,
      showOnMapCallback: getExternalRetailDataDetail,
      colorRange: Constant.COLOR_RANGE.SKY_ORANGE_RANGE,
    },
    {
      dataObject: foodAndBeverageDemand,
      attributeName: "total_transaction",
      type: "single_number",
      unit: "giao dịch",
      title: "Nhu cầu F&B",
      isLoading: isGetExternalFoodAndBeverageData,
      showOnMapCallback: getExternalFoodAndBeveragePoints,
      colorRange: Constant.COLOR_RANGE.BLUE_RANGE,
    },
    {
      dataObject: foodAndBeverageCategoryDemand,
      type: "bar_chart",
      title: "Loại nhu cầu F&B",
      attributeName: "food_and_beverage_category_demand",
      subAttributeLabelName: "category",
      subAttributeValueName: "total_transaction",
      isLoading: isGetExternalFoodAndBeverageData,
      height: 60,
    },
    {
      dataObject: foodAndBeverageDeliveryDemand,
      attributeName: "total_transaction",
      type: "single_number",
      unit: "giao dịch",
      title: "Nhu cầu F&B Delivery",
      isLoading: isGetExternalFoodAndBeverageDeliveryData,
      showOnMapCallback: getExternalFoodAndBeverageDeliveryPoints,
      colorRange: Constant.COLOR_RANGE.ORANGE_RANGE,
    },
    {
      dataObject: staticDemand,
      attributeName: "total_transaction",
      type: "single_number",
      unit: "giao dịch",
      title: "Nhu cầu Static",
      isLoading: isGetStaticDemandData,
      showOnMapCallback: getStaticDemandPoints,
      colorRange: Constant.COLOR_RANGE.PURPLE_RANGE,
    },
  ];
  const nearbyLocationDataWidget = {
    dataObject: nearbyLocationTypeSummary,
    attributeName: "location_type_summary",
    type: "list_key_value",
    title: "Xung quanh đây có",
    isLoading: isGetNearbyLocationSummary,
    showOnMapCallback: getStaticDemandPoints,
    keyName: "location_type_name",
    valueName: "number_of_locations",
    onListItemClick: nearbyLocationTypeSelection,
  };
  if (showNearbyLocationFirst) {
    summaryDataLayout.unshift(nearbyLocationDataWidget);
  } else {
    summaryDataLayout.push(nearbyLocationDataWidget);
  }
  return (
    <Col
      xs={12}
      sm={4}
      md={3}
      className={
        embedMode
          ? "site-planning__section__embed-mode"
          : "site-planning__section"
      }
    >
      <div className="site-planning__planning-zone-controls">
        <Button
          size="sm"
          color={showPlanningPolygon ? "secondary" : "primary"}
          onClick={toggleShowPlanningPolygons}
          style={{ width: "100%", marginBottom: 12 }}
        >
          {showPlanningPolygon ? "Ẩn " : "Hiện "} planning zone trên bản đồ
        </Button>
        {mapBoundary && (
          <a
            href={`/planning/list?mapBoundary=${JSON.stringify(mapBoundary)}`}
            target="_blank"
          >
            Danh sách planning zone trong khu vực
          </a>
        )}
      </div>
      <div
        className={`site-planning__right-side-bar ${
          embedMode ? "site-planning__embed-mode" : ""
        }`}
      >
        {showPlanningPolygon && (
          <FormGroup>
            <CustomInput
              className="site-planning__map-toolbar_section-switch"
              id="showPlanningZoneTitleCustomInput"
              type="switch"
              label="Hiển thị tên cho zone"
              onChange={(e) =>
                setMapSettings("showPlanningZoneTitle", e.target.checked)
              }
              checked={mapSettings.showPlanningZoneTitle}
            />
          </FormGroup>
        )}
        <SelectedPolygon
          editPlanningPolygon={editPlanningPolygon}
          planningPolygons={planningPolygons}
          selectedFeatureIndexes={selectedFeatureIndexes}
          toggleSitePlanningCommentUI={toggleSitePlanningCommentUI}
        />
        {!mapBoundary && (
          <p>
            <b>Hãy zoom bản đồ để bắt đầu</b>
          </p>
        )}
        {summaryDataLayout.map((layoutItem, index) => (
          <DataWidget
            key={`data-widget-${index}`}
            dataObject={layoutItem.dataObject || summaryData}
            attributeName={layoutItem.attributeName}
            type={layoutItem.type}
            unit={layoutItem.unit}
            title={layoutItem.title}
            subAttributeLabelName={layoutItem.subAttributeLabelName}
            subAttributeValueName={layoutItem.subAttributeValueName}
            isLoading={layoutItem.isLoading}
            showOnMapCallback={layoutItem.showOnMapCallback}
            height={layoutItem.height}
            colorRange={layoutItem.colorRange}
            valueName={layoutItem.valueName}
            keyName={layoutItem.keyName}
            onListItemClick={layoutItem.onListItemClick}
            customFooterComponent={layoutItem.customFooterComponent}
          />
        ))}
      </div>
    </Col>
  );
};

export default RightCorner;
